module.exports = __webpack_public_path__ + "img/heart.e6b9bf1d.svg";